import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { api, formatApiError } from "@/lib/api";
import { BackButton } from "@/components/BackButton";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [doneMsg, setDoneMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      setDoneMsg("Password updated. You can sign in now.");
      setTimeout(() => navigate("/auth"), 2000);
    } catch (e) {
      setError(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main data-testid="reset-password-page" className="flex min-h-screen flex-col items-center justify-center bg-bone px-6">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="w-full max-w-md">
        <BackButton />
        <Link to="/" className="mb-10 flex justify-center">
          <img src="/logo.webp" alt="Shop ONline New York" className="h-16 w-auto mix-blend-multiply" />
        </Link>
        <h1 className="text-center font-serif text-4xl font-light tracking-tight">Choose a new password</h1>
        <div className="mt-10 space-y-4">
          <input
            data-testid="reset-password-input"
            type="password"
            placeholder="New password — at least 8 characters"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-md border border-charcoal/20 bg-transparent px-4 py-3 text-sm outline-none placeholder:text-ash/60 focus:border-charcoal"
          />
          {error && <p data-testid="reset-error" className="text-sm text-moss">{error}</p>}
          {doneMsg && <p data-testid="reset-success" className="text-sm text-charcoal">{doneMsg}</p>}
          <button
            data-testid="reset-submit"
            onClick={submit}
            disabled={busy || !token}
            className="w-full rounded-full bg-charcoal py-4 text-xs uppercase tracking-[0.2em] text-bone transition-colors duration-300 hover:bg-moss disabled:opacity-60"
          >
            Update password
          </button>
        </div>
      </motion.div>
    </main>
  );
}
